import Button from '../components/Button/Button.builder.js';
import ContactForm from '../components/ContactForm/ContactForm.builder.js';
import HeroBanner from '../components/HeroBanner/HeroBanner.builder.js';
import ImpressiveNumbers from '../components/ImpressiveNumbers/ImpressiveNumbers.builder.js';
import InterestingNumbers from '../components/InterestingNumbers/InterestingNumbers.builder.js';
import LogosList from '../components/LogosList/LogosList.builder.js';
import PageHeading from '../components/PageHeading/PageHeading.builder.js';
import SourceBadges from '../components/SourceBadges/SourceBadges.builder.js';
import UspRow from '../components/UspRow/UspRow.builder.js';

export default [
  Button,
  ContactForm,
  HeroBanner,
  ImpressiveNumbers,
  InterestingNumbers,
  LogosList,
  PageHeading,
  SourceBadges,
  UspRow
];